// extracted by mini-css-extract-plugin
export default {"header":"Header_header__g2BdF","icon":"Header_icon__Ry3wn","social":"Header_social__0csAV"};